export default __webpack_public_path__ + "fd5c73f7e33f635741386367757b631b.png";